import EnvironmentEnum from 'src/enums/environment';

const Config = {
  Env: process.env.REACT_APP_NODE_ENV,
  Common: {
    Subdomain: 'admin',
    ApiBaseUrl: 'http://localhost:8080',
    ApiKey: 'testerino',
    AppName: 'Viviboom',
    FrontEndUrl: 'http://localhost:3028',
    AdminFrontEndUrl: 'http://localhost:3029',
    MobileAppUrl: 'https://mobile.viviboom.co',
    SupportEmailName: 'mail',
    SupportEmailDomain: 'mail.com',
    CometChatAppId: '33469f674582430',
    CometChatRegion: 'eu',
    CometChatApiKey: '9f034baaffbd09b6fb210c0828aa99de51b66e17',
    BuilderAppId: '89eb27fc1b6a4fa68a17b4eb34dfec52',
  },
};

if (process.env.REACT_APP_NODE_ENV === EnvironmentEnum.Release) {
  Config.Common.ApiBaseUrl = 'https://release-api.viviboom.co';
  Config.Common.FrontEndUrl = 'https://www.release.viviboom.co';
  Config.Common.AdminFrontEndUrl = 'https://www.release-admin.viviboom.co';
  Config.Common.CometChatAppId = '33469f674582430';
  Config.Common.BuilderAppId = '89eb27fc1b6a4fa68a17b4eb34dfec52';
}

if (process.env.REACT_APP_NODE_ENV === EnvironmentEnum.Production) {
  Config.Common.ApiBaseUrl = 'https://api.viviboom.co';
  Config.Common.FrontEndUrl = 'https://viviboom.co';
  Config.Common.AdminFrontEndUrl = 'https://www.admin.viviboom.co';
  Config.Common.CometChatAppId = '3402064f7e99fa9';
  Config.Common.CometChatApiKey = '79debb3c830f115cef8c5bc1255cf693e613dfec';
  Config.Common.BuilderAppId = 'ecc7481e653d4da8828368fd1aeafee0';
}

Config.Common.CloudFrontFull = `${Config.Common.CloudFrontUrl}/${Config.Common.CloudFrontIndentifier}`;

export default Config;
